import { lazy } from 'react';
import OrderCategory from './OrderCategory';
import OrderCategoryForm from './OrderCategoryForm';

const OrderCategoryConfig = {
    settings: {
        layout: {
            config: {},
        },
    },
    routes: [
        {
            path: '/orderCategory',
            element: <OrderCategory />,
        },
        {
            path: '/addOrderCategory',
            element: <OrderCategoryForm />,
        },
        {
            path: '/editOrderCategory/:id',
            element: <OrderCategoryForm />,
        },
    ],
};

export default OrderCategoryConfig;
